<!-- src/components/icons/HamburgerIcon.vue -->
<template>
 <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currnetColor"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C17.7712 3 19.6569 3 20.8284 4.17157C22 5.34315 22 7.22876 22 11V13C22 16.7712 22 18.6569 20.8284 19.8284C19.6569 21 17.7712 21 14 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11Z" stroke="currentColor" stroke-width="1.5"></path> <path d="M15 21L15 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>   
 </template>

  <script>
  export default {
    name: "LotoutIcon",
    props: {
      width: {
        type: String,
        default: "20px",
      },
      height: {
        type: String,
        default: "20px",
      },
      strokeColor: {
        type: String,
        default: "#ffffff",
      },
      strokeWidth: {
        type: [String, Number],
        default: 1.5,
      },
    },
  };
  </script>